import NoticeIcon from 'assets/icons/notice-yellow-icon.svg';
import TxnSubmitErrorPopup from 'components/common/PortalModal/popups/TxnSubmitErrorPopup';
import { useDetectDevice } from 'hooks/useDetectDevice';
import usePortalModal from 'hooks/usePortalModal';
import { functionUtils } from 'utils';

const TxnSubmitErrorModal = ({
  isShow,
  title,
  content,
  action,
  actionClose,
  modalStyles,
  modalData,
  modalOptions,
}) => {
  const { closePortalModalName } = usePortalModal();
  const { isDesktop } = useDetectDevice();

  const { buttonLabel1, buttonLabel2 } = modalOptions || {};

  const handleOnClick = () => {
    if (functionUtils.isFunction(action)) {
      action();
    }
    closePortalModalName();
  };

  const handleOnClose = () => {
    if (functionUtils.isFunction(actionClose)) {
      actionClose();
    }
    // Deferred by one microtask so this modal's close lands in a separate
    // React commit from actionClose's store update. For the Step-2 flow,
    // actionClose traces to useTxnSubmitError's onCleanup -> onTOCleanup ->
    // resetAddTransactionCurrentStep, whose setAddTransactionCurrentStep(0)
    // swaps AddTransactionPage/ver2's stepContentReference subtree
    // (Remittance -> ReceiverPayoutMethod) in the same commit. Closing this
    // modal in that same commit can land a new PortalModal mount and that
    // subtree's unmount together, racing react-bootstrap's Transition and
    // crashing (browser-smoke#148, mirrors #147's fix).
    queueMicrotask(() => closePortalModalName());
  };

  return (
    <TxnSubmitErrorPopup
      isOpen={isShow}
      imageSrc={NoticeIcon}
      imagesStyles={{
        width: isDesktop ? '124px' : '75px',
        height: isDesktop ? '100px' : '60px',
      }}
      text={title || ''}
      content={content || ''}
      buttonLabel1={buttonLabel1}
      onClose={handleOnClose}
      buttonLabel2={buttonLabel2}
      onClick={handleOnClick}
      isBackdropOverlap={true}
      zIndexBackdropOverlap={1055}
      modalStyles={modalStyles}
      modalData={modalData}
    />
  );
};

export default TxnSubmitErrorModal;
